import React, { useEffect, useState } from 'react'
import { Slide } from 'pure-react-carousel'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { CMS_BLOCK as LIVBRITE_CMS } from 'app/livbrite/resources/constants'
import { Carousel } from 'components/Slider'
import { useStoreView } from 'hooks/useStoreView'
import { SlideContent } from './styled'

export const PromotionalBanner = () => {
  const { isSofiaAndGrace } = useStoreView()
  const [slides, setSlides] = useState<HTMLDivElement[] | undefined>()
  const staticBlockID = isSofiaAndGrace ? CMS_BLOCK.PROMO_BANNER : LIVBRITE_CMS.PROMO_BANNER
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: true
  })

  useEffect(() => {
    if (staticBlock.content) {
      var parser = new DOMParser()
      const document = parser.parseFromString(staticBlock.content, 'text/html')
      const slides = document.getElementsByTagName('div')
      setSlides(Array.from(slides))
    }
  }, [staticBlock.content])

  if (!staticBlock.content || !slides) return null

  return (
    <Carousel
      child={slides}
      renderChildren={(children: any[]) => {
        return slides?.map((child: any, index: number) => {
          return (
            <Slide index={index} key={index}>
              <SlideContent
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML
                }}
              />
            </Slide>
          )
        })
      }}
      autoPlay
      arrowsEnabled
      autoHeight
      isPromo
    />
  )
}
